export interface Retrofit {
    cost: number;
    savings: number;
    paybackPeriod: number; // in years
}

export interface RetrofitOption {
    id: string;
    name: string;
    description: string;
    category: RetrofitCategory;
    averageCostPerSqFt: number;
    averageEnergyReduction: number; // percentage
    averageGHGReduction: number; // percentage
    typicalPaybackPeriod: number; // years
    applicableBuildingTypes: string[];
}

export enum RetrofitCategory {
    HVAC = 'HVAC',
    LIGHTING = 'Lighting',
    BUILDING_ENVELOPE = 'Building Envelope',
    RENEWABLE_ENERGY = 'Renewable Energy',
    ENERGY_MANAGEMENT = 'Energy Management',
    WATER_HEATING = 'Water Heating'
}

export interface RetrofitPackage {
    id: string;
    name: string;
    retrofitOptions: RetrofitOption[];
    totalCost: number;
    totalEnergyReduction: number;
    totalGHGReduction: number;
    combinedPaybackPeriod: number;
    netPresentValue: number;
    ll97SavingsVsCost: number; // ratio of LL97 savings to retrofit cost
}

export interface RetrofitRecommendation {
    id: string;
    title: string;
    name?: string;
    description: string;
    category: RetrofitCategory;
    estimatedCost: number;
    estimatedSavings: number;
    paybackPeriod: number;
    priority: 'urgent' | 'high' | 'medium' | 'low';
    energyReduction: number;
    emissionReduction: number;
    ghgReduction?: number;
    implementation?: {
        phases: string[];
        timeline: string;
        requirements: string[];
    };
}